import * as styles from './BreakLine.module.css';

const BreakLine = () => <div data-testid="break-line" className={styles.breakLine} />;

export default BreakLine;
